export default __webpack_public_path__ + "b9ddeb29.woff2";